

import Vue         from 'vue'
import App         from './App.vue'
import VueRouter   from 'vue-router';
import Vuex        from 'vuex';
import store       from './store/store';
import VeeValidate from 'vee-validate';

import Mixins      from './mixins/global.js';
// componenets
import Login              from './components/Login.vue'
import Home               from './components/Home.vue'
import Navigation         from './components/Navigation.vue'
import Redeem             from './components/Redeem.vue'
import RedeemAmount       from './components/RedeemAmount.vue'
import RedeemConfirmation from './components/RedeemConfirmation.vue'
import Redeemed           from './components/Redeemed.vue'
import CurrencyInput      from './components/CurrencyInput.vue'
import TextInput          from './components/TextInput.vue'
import Cta                from './components/Cta.vue'
import Pin                from './components/Pin.vue'
import Redemptions        from './components/Redemptions.vue'
import Site               from './components/Site.vue'
import NotFound           from './components/NotFound.vue'
import Maintenance        from './components/Maintenance.vue'
import CurrentSite        from './components/CurrentSite.vue'
import Sell               from './components/Sell.vue'
import DigitalSend        from './components/DigitalSend.vue'
import Payment            from './components/Payment.vue'
import FocReason          from './components/FocReason.vue'
import GiftUniqueCode     from './components/GiftUniqueCode.vue'
import Receipt            from './components/Receipt.vue'
import SellSuccess        from './components/SellSuccess.vue'
import VModal             from 'vue-js-modal';
import Twofactor          from './components/Twofactor.vue'
import Scan               from './components/Scan.vue'
import RedeemTicket       from './components/RedeemTicket.vue'
import RedeemTicketSuccess  from './components/RedeemTicketSuccess.vue'
import RedeemTicketError  from './components/RedeemTicketError.vue'

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
//import './registerServiceWorker'


import 'bootstrap/dist/css/bootstrap.css';

Vue.component('date-time-picker', VueCtkDateTimePicker);
Vue.component('currency-input', CurrencyInput);
Vue.component('current-site', CurrentSite);
Vue.component('text-input', TextInput);
Vue.component('cta', Cta);

require('./assets/scss/globals.scss');
require('./assets/scss/text.scss');
require('./assets/scss/inputs.scss');
require('./assets/scss/buttons.scss');
require('./assets/scss/animations.scss');
require('./assets/scss/modals.scss');

Vue.mixin({
    methods:Mixins
});

// Init store to last saved state
store.commit('INITIALISE_STORE');

/**
 * Update the local storage whenever the store state changes.
 * this allows us to load back in the store where you left of
 * when the user returns to the page
 */

store.subscribe((mutation, state) => {
    // Store the state object as a JSON string
    localStorage.setItem('store', JSON.stringify(state));
});

/**
* Create a global event bus. We use this to transmit data to/from components
*/
Object.defineProperty(Vue.prototype, '$bus', {
    get() {
        return this.$root.bus;
    }
});
var bus = new Vue();

Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VModal);



/**
* Validation
*/

const dictionary = {
  en: {
    messages: {
        required:() => {
            return "This field is required"
        },
        included:() => {
            return "This field is required"
        },
        min:() => {
            return "Looks like you've not put enough characters in!"
        },
        max:() => {
            return "Looks like you've put too many characters in!"
        },
        min_value:() => {
            return "This needs to be a higher number"
        },
        max_value:() => {
            return "This needs to be a lower number"
        },
        url:() => {
            return "This field must be a url"
        },
        email:() => {
            return "This field must be a valid email address"
        },
        confirmed:() => {
            return "This field must match the one above"
        }
    }
  }
};
const config = {
    errorBagName     : 'errors', // change if property conflicts.
    fieldsBagName    : 'inputs ', //Default is fields
    delay            : 0,
    locale           : 'en',
    dictionary       : dictionary,
    strict           : true,
    enableAutoClasses: false,
    classNames       : {
        touched          : 'touched', // the control has been blurred
        untouched        : 'untouched', // the control hasn't been blurred
        valid            : 'valid', // model is valid
        invalid          : 'invalid', // model is invalid
        pristine         : 'pristine', // control has not been interacted with
        dirty            : 'dirty' // control has been interacted with
    },
    events           : 'input|blur',
    inject           : false
};

Vue.use(VeeValidate, config);


/**
* Axios
*/

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


/**
 * Add an axios interceptor to send the the app's version config to the sever.
 */

window.axios.interceptors.request.use((config)=>{
    // on ever request add the app's utility versions to a header, 
    // to ensure that the current session is using the latest version - if it's not we need to update the app
    let version = store.getters.getApp;
    version.app_id = 3;
    config.headers.common['X-App-Version'] = JSON.stringify(version);
    return config;
});


/**
* Add an axios interceptor to check every response for
* an authorisation or refresh token header. If it exists, then add it to the store/localstorage
* for use in subsequent requests.
* Also check for an unauthorised error, if present log the user out and send to the login screen.
*/

window.axios.interceptors.response.use(function (response) {
    const authed = store.getters.getLoggedIn; // is logged in?
    // Do something with response data
    if(response.headers['x-authorization'] !== undefined )
        store.dispatch('refreshUserToken', response.headers['x-authorization']);

    // if this header is present, then the app needs to refresh it's cache and the user needs to re-login
    if(response.headers['x-refresh-local-cache']){
        var version = store.getters.getApp;
        var logout = version.version_increment ? true : false;
        if(logout)
            store.commit('RESET_STORE');
        store.commit('SET_APP', JSON.parse(response.headers['x-refresh-local-cache']));
        if(authed && logout)
            store.dispatch('logout');
    }

    if(response.headers['x-remember-token']){
        localStorage.setItem('x-remember-token', response.headers['x-remember-token']);
    }

    // If unauthorised, then log this user out
    if(response.data.errors !== undefined ){
        for (var i = 0, len = response.data.errors.length; i < len; i++)
            if(authed && response.data.errors[i].message == 'Unauthorized')
                store.dispatch('logout');
    }

    // If unauthorised in twofa journey, log the user out
    if(response.data[0] ){
        if(authed && response.data[0].errors) {
            if(response.data[0].errors[0].message == 'Unauthorized') store.dispatch('logout');
        }
    }

    return response;
},  (error) => {
    if(error.response && error.response.status == 503)
        router.push({ name: 'maintenance'});
    
// Do something with response error
    return Promise.reject(error);
});

/**
* Add an axios interceptor to check if we have an quth token in the store
* if we do, then add it as a header to every request
*/

window.axios.interceptors.request.use((config)=>{
    const token = store.getters.getUserToken;
    if (token) {
       config.headers.common['Authorization'] = 'Bearer ' + token
    }

    // on ever request add the app's utility versions to a header,
    // to ensure that the current session is using the latest version - if it's not we need to update the app
    let version = store.getters.getApp;
    version.app_id = 2;
    config.headers.common['X-App-Version'] = JSON.stringify(version);

    return config;

});


/**
* Router
*/

const routes = [
	{
		path: '/',
		name: 'home',
		components: {
            default:Home,
            navigation:Navigation,
            currentsite:CurrentSite
        },
		meta: { 
            title: 'Toggle POS Mode',
            auth:true
        }
	},
    {
		path: '/twofactor',
		name: 'twofactor',
		components: {
            default:Twofactor,
            navigation:Navigation,
            currentsite:CurrentSite
        },
		meta: { 
            title: 'Toggle POS Mode',
            auth:true
        }
	},
    {
        path: '/redeem',
        name: 'redeem',
        components: {
            default:Redeem,
            navigation:Navigation,
            currentsite:CurrentSite
        },
        meta: { 
            title: 'Toggle POS Mode',
            auth:true
        }
    },
    {
        path: '/redeem-amount',
        name: 'redeem-amount',
        components: {
            default:RedeemAmount,
            navigation:Navigation,
            currentsite:CurrentSite
        },
        meta: { 
            title: 'Toggle POS Mode',
            auth:true
        }
    },
    {
        path: '/redeem-confirmation',
        name: 'redeem-confirmation',
        components: {
            default:RedeemConfirmation,
            navigation:Navigation,
            currentsite:CurrentSite
        },
        meta: { 
            title: 'Toggle POS Mode',
            auth:true
        }
    },
    {
        path: '/redeemed',
        name: 'redeemed',
        components: {
            default:Redeemed,
            navigation:Navigation,
            currentsite:CurrentSite
        },
        meta: { 
            title: 'Toggle POS Mode',
            auth:true
        }
    },
	{
		path: '/login',
		name: 'login',
		component: Login,
		meta: { 
            title: 'Toggle POS Mode',
            auth:false
        }
	},
    {
        path: '/pin',
        name: 'pin',
        component: Pin,
        meta: { 
            title: 'Toggle POS Mode',
            auth:true
        }
    },
    {
        path: '/redemptions',
        name: 'redemptions',
        components: {
            default:Redemptions,
            navigation:Navigation,
            currentsite:CurrentSite
        },
        meta: { 
            title: 'Toggle POS Mode',
            auth:true
        }
    },
    {
        path: '/site',
        name: 'site',
        components: {
            default:Site,
            navigation:Navigation,
            currentsite:CurrentSite
        },
        meta: { 
            title: 'Toggle POS Mode',
            auth:true
        }
    },
    {
        path: '/sell',
        name: 'sell',
        components: {
            default:Sell,
            navigation:Navigation,
            currentsite:CurrentSite
        },
        meta: { 
            title: 'Toggle POS Mode',
            auth:true
        }
    },
    {
        path: '/digital-gift',
        name: 'digital-gift',
        components: {
            default: DigitalSend,
            navigation: Navigation,
            currentsite: CurrentSite
        },
        meta: {
            title: 'Toggle POS Mode',
            auth: true
        }
    },
    {
        path: '/payment',
        name: 'payment',
        components: {
            default: Payment,
            navigation: Navigation,
            currentsite: CurrentSite
        },
        meta: {
            title: 'Toggle POS Mode',
            auth: true
        }
    },
    {
        path: '/foc-reason',
        name: 'foc-reason',
        components: {
            default: FocReason,
            navigation: Navigation,
            currentsite: CurrentSite
        },
        meta: {
            title: 'Toggle POS Mode',
            auth: true
        }
    },
    {
        path: '/gift-unique-code',
        name: 'gift-unique-code',
        components: {
            default: GiftUniqueCode,
            navigation: Navigation,
            currentsite: CurrentSite
        },
        meta: {
            title: 'Toggle POS Mode',
            auth: true
        }
    },
    {
        path: '/receipt',
        name: 'receipt',
        components: {
            default: Receipt,
            navigation: Navigation,
            currentsite: CurrentSite
        },
        meta: {
            title: 'Toggle POS Mode',
            auth: true
        }
    },
    {
        path: '/sell-success',
        name: 'sell-success',
        components: {
            default: SellSuccess,
            navigation: Navigation,
            currentsite: CurrentSite
        },
        meta: {
            title: 'Toggle POS Mode',
            auth: true
        }
    },
    {
        path: '/maintenance',
        name: 'maintenance',
        components: {
            default:Maintenance,
        },
        meta: { 
            title: '503'
        }
    },
    {
        path: '/scan',
        name: 'scan',
        components: {
            default: Scan,
            navigation: Navigation,
            currentsite: CurrentSite
        },
        meta: { 
            title: 'Toggle POS Mode',
            auth:true
        }
    },
    {
        path: '/redeem-ticket',
        name: 'redeem-ticket',
        components: {
            default: RedeemTicket,
            navigation: Navigation,
            currentsite: CurrentSite
        },
        meta: { 
            title: 'Toggle POS Mode',
            auth:true
        }
    },
    {
        path: '/redeem-ticket-success',
        name: 'redeem-ticket-success',
        components: {
            default: RedeemTicketSuccess,
            navigation: Navigation,
            currentsite: CurrentSite
        },
        meta: { 
            title: 'Toggle POS Mode',
            auth:true
        }
    },
    {
        path: '/redeem-ticket-error',
        name: 'redeem-ticket-error',
        components: {
            default: RedeemTicketError,
            navigation: Navigation,
            currentsite: CurrentSite
        },
        meta: { 
            title: 'Toggle POS Mode',
            auth:true
        }
    },
    {
        path: '*',
        name:'catchall',
        components: {
            default:NotFound,
        },
        meta: { 
            title: '404'
        }
    }

	
];

const router = new VueRouter({
    routes, // short for routes: routes
    mode: 'history',
    fallback: true,
    scrollBehavior () {
      return { x: 0, y: 0 }
    }
});

// router middleware
router.beforeEach((to, from, next) => {

    // Update page title to route title
    document.title = to.meta.title + (to.meta.title_append_param !== undefined ? ' ' + to.params[to.meta.title_append_param] : '');
    // Does this route require the user to be logged in?
    const authRequired = to.matched.some((route) => route.meta.auth);
    // Does this route require the user to be logged out?
    const notauthedRequired = to.matched.some((route) => route.meta.notauthed);
    // is the user logged in?
    const authed = store.getters.getLoggedIn;

    let pin_locked = store.getters.getPinLocked; 
    // is app locked by a pin?

	// if route requires not to be logged in and you are logged in, then log you out
    if(notauthedRequired && authed)
        store.dispatch('logout');

	// if route requires to be logged in and you are logged out, then redirect to login page
    if (authRequired && !authed && to.name != 'login') {
        if(to.name != 'pin' && to.name != 'maintenance')
            store.commit("SET_INTENDED_URL",to.name);
        next({name:'login'});
    }
    else{
        // if user has not had two factor code verified and tries to access routes other than twofactor they should be logged out.
        let twofactor_complete = store.getters.getTwofactorComplete;
        if(authed && !twofactor_complete){
            if( to.name != 'twofactor' && to.name != 'login') next({name:'login'});
        } 

        if(authed && to.meta.auth && to.name != 'site' && from.name != 'login'  && (!store.getters.getAccount || !store.getters.getUnit) && to.name != 'pin'){ // if the account/unit is not set send them to the site screen for them to pick
            if(from.name == 'site'){
                bus.$emit('error_message', 'You must select a site before continuing.');
            } else {
                next({name:'site'});
            }   
        }
        else if(authed && to.name != 'pin' && from.name != 'login' && pin_locked && to.meta.auth && to.name != 'site'){ // if locked by pin send them to the pin page
            next({name:'pin'});
        }
        else
            next(); 
    }

});

Vue.config.productionTip = false

new Vue({
	el: '#app',
	data: {
        bus:bus, // our global event bus
        timeout:process.env.VUE_APP_PIN_LOCK_TIMEOUT_SECONDS
    },
	router,
	store: store,
	template: '<App/>',
	components: { App },
    created:function(){
        document.addEventListener("keydown", ()=>{
            this.resetTimout();
        });
        document.addEventListener("click", ()=>{
            this.resetTimout();
        });
        setInterval(() => { 
            if(this.timeout > 0){
                this.timeout--;
            } else if(this.$route.name != 'pin' && this.$route.name != 'login' && this.$route.name != 'site' && this.$route.name != 'maintenance'){ // site should not timeout to the pin because you need the account in order to know what the pin is
                store.commit("SET_PIN_LOCKED",true);
                store.commit("SET_INTENDED_URL",this.$route.name);
                this.$router.push({ name: 'pin'});
            }
        }, 1000);   
    },
    methods:{
        resetTimout(){
            this.timeout = process.env.VUE_APP_PIN_LOCK_TIMEOUT_SECONDS;
        },
    }
})